import React from 'react'
import Loader from '../../../components/Loader'
import styled from 'styled-components'
import Colors from '../../../assets/styles/Colors'
import Title from '../../../components/v2/Title'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Responsive from '../../../assets/config/Responsive'
import HorizontalCard from '../../../components/v2/HorizontalCard'
import RadioButton from '../../../components/v2/buttons/RadioButton'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import CurrencyIcon from '../../../assets/v2/JSX/CurrencyIcon'
import { CriticalIllnessState, setCurrency, setLimit } from '../../../store/criticalIllnessSlice'
import { useAppDispatch, useAppSelector } from '../../../store'
import CriticalProgressbar from '../../../components/v2/progrees-bars/CriticalProgressbar'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import { currencySymbol } from '../../../domain/types'
import api from '../../../api'
import { AppState } from '../../../store/appSlice'

const CriticalCurrencyAndLimit = () => {
  //
  const navigate = useNavigate()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const dispatch = useAppDispatch()
  //
  const { filter, screenHeader } = useAppSelector((data: { critical: CriticalIllnessState }) => data.critical)
  //
  const { t } = useTranslation()
  //
  const { data: pageInfo, isLoading: isPageInfoLoading } = api.useGetPetPageInfoQuery('critical-select-currency-limit')
  //
  const pageTitle = pageInfo?.translations?.[lang]?.title
  const stepName = pageInfo?.translations?.[lang]?.stepName
  const listItems = pageInfo?.listItems?.slice().sort((a, b) => a.sort - b.sort)
  //
  const leftCompanies = {
    companiesCount: 2,
  }
  //
  const fakeData = {
    limits: [
      {
        id: 1,
        value: 20000,
      },
      {
        id: 2,
        value: 25000,
      },
    ],
  }
  //
  //
  const mainLoading = isPageInfoLoading

  return mainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={pageTitle} />

        <CriticalProgressbar stepName={stepName} />

        <Block>
          <Cards>
            {listItems?.map((item) => {
              return (
                <HorizontalCard
                  className="horizontal-card"
                  key={item.id}
                  title={item?.translations?.[lang]?.title}
                  imgCHildren={<CurrencyIcon />}
                  selected={item.type === filter.currency}
                  onClick={() => {
                    if (item.type) {
                      dispatch(setCurrency(item.type))
                      //
                      if (filter.currency !== item.type) {
                        dispatch(setLimit(null))
                      }
                    }
                  }}
                >
                  {item.type === filter.currency && (
                    <LimitDiv>
                      <hr />
                      <LimitTitle>{t('chooseLimit')}</LimitTitle>
                      <LimitDescription>{t('maximumLimit')}</LimitDescription>

                      <CheckboxBlock>
                        <RadioButton
                          size="small"
                          defaultOption={filter.limit}
                          onChange={(value) => dispatch(setLimit(Number(value)))}
                          options={
                            fakeData.limits
                              ? [
                                  ...fakeData.limits?.map((item) => ({
                                    value: item.value,
                                    label:
                                      item?.value?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') +
                                      ` ${currencySymbol(filter.currency)}`,
                                  })),
                                ]
                              : []
                          }
                        />
                      </CheckboxBlock>
                    </LimitDiv>
                  )}
                </HorizontalCard>
              )
            })}
          </Cards>
          <RemainingCompanies
            style={{
              opacity: leftCompanies ? '1' : '0',
              marginInline: 'auto',
            }}
            text={`${t('offerAvailable')}: ${leftCompanies?.companiesCount} `}
          />
        </Block>
        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => [navigate('/critical-start-date')]}
          />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={filter.currency && filter.limit ? false : true}
            onClick={() => [navigate('/critical-add-insured')]}
          />
        </Buttons>
      </Content>
      <BackgroundIcon />
    </Wrapper>
  )
}
const Block = styled.div`
  max-width: 464px;
  width: 100%;
  margin-inline: auto;
`
const CheckboxBlock = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 10px;
`
const LimitTitle = styled.p`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 1px;
`
const LimitDescription = styled.p`
  font-size: 14px;
  color: ${Colors.nevadaGrey};
  margin-bottom: 18px;
`
const LimitDiv = styled.div``

const Buttons = styled.div`
  display: flex;
  gap: 20px;
  width: min-content;
  margin-top: 48px;
  margin-inline: auto;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    margin-top: 40px;
    gap: 16px;
    button {
      width: 140px;
    }
  }
`

const Cards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
  max-width: 464px;
  width: 100%;

  .horizontal-card-content {
    align-items: center;
  }

  .horizontal-card {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0px;
    }
  }

  ${Responsive.mobile} {
    margin-top: 24px;

    .horizontal-card {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
`
const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  position: relative;
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  min-height: 100vh;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  /*  */
`

export default CriticalCurrencyAndLimit
